import { getCdnUrl } from '~/utils/mediaUtils'

/**
 * Lambda 이미지 리사이징 URL 생성
 * @param {string} src - 원본 이미지 경로
 * @param {string} detail - 이미지 타입 (desc, list, card, thumb, main, sub, banner, profile, badge, capture)
 * @param {string} size - 이미지 크기 (60, 300, 850, 300x400, 100x100, original)
 * @returns {string} CDN이 포함된 Lambda URL
 */
export function buildLambdaUrl (src, detail, size) {
  if (!src) {
    return ''
  }

  let cleanSrc = src

  // 이미 CDN URL인 경우 경로만 추출
  if (cleanSrc.startsWith('http://') || cleanSrc.startsWith('https://')) {
    try {
      const url = new URL(cleanSrc)
      cleanSrc = url.pathname
    } catch (e) {
      console.warn('[buildLambdaUrl] Invalid URL:', cleanSrc)
      return ''
    }
  }

  // dims 경로 제거
  cleanSrc = cleanSrc.replace(/\/dims\/.*$/, '')

  // 이미 Lambda 이미지 URL이면 중복으로 /file/resize를 덧붙이지 않는다.
  if (cleanSrc.startsWith('/file/resize/')) {
    return getCdnUrl(cleanSrc)
  }

  // /file/로 시작하지 않으면 static 이미지로 간주 (Lambda 거치지 않음)
  if (!cleanSrc.startsWith('/file/')) {
    return getCdnUrl(cleanSrc)
  }

  const pathParts = cleanSrc.replace(/^\/file\//, '').split('/')

  if (pathParts.length < 3) {
    console.warn('[buildLambdaUrl] Invalid path structure:', cleanSrc)
    return getCdnUrl(cleanSrc)
  }

  const [folder, date, ...filenameParts] = pathParts
  const filename = filenameParts.join('/')

  const url = `/file/resize/${folder}/${date}/${detail}/${size}/${filename}`

  return getCdnUrl(url)
}

/**
 * HTML 내의 img 태그 src를 Lambda 리사이징 URL로 변환
 * @param {string} html - 원본 HTML 문자열
 * @param {string} detail - 이미지 타입 (desc, list, card, thumb, main, sub, banner, profile, badge, capture)
 * @param {string} size - 이미지 크기 (60, 300, 850, 300x400, 100x100, original)
 * @returns {string} 변환된 HTML 문자열
 */
export function transformHtmlImages (html, detail, size) {
  if (!html) {
    return ''
  }

  // HTML 엔티티 디코딩
  const textarea = document.createElement('textarea')
  textarea.innerHTML = html
  const decodedHtml = textarea.value

  // console.log('[transformHtmlImages] original:', html)
  // console.log('[transformHtmlImages] decoded:', decodedHtml)

  const parser = new DOMParser()
  const doc = parser.parseFromString(decodedHtml, 'text/html')
  const images = doc.querySelectorAll('img')

  // console.log('[transformHtmlImages] found images:', images.length)

  images.forEach((img) => {
    const src = img.getAttribute('src')
    // console.log('[transformHtmlImages] original src:', src)
    if (src) {
      const newSrc = buildLambdaUrl(src, detail, size)
      // console.log('[transformHtmlImages] new src:', newSrc)
      img.setAttribute('src', newSrc)
    }
  })

  const result = doc.body.innerHTML
  // console.log('[transformHtmlImages] result:', result)
  return result
}
